import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, DEFAULT_SITE } from "../lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(DEFAULT_SITE);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSite({ ...DEFAULT_SITE, ...r.data });
    } catch (error) {
      console.error("Failed to load site settings:", error);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ site, refresh }), [site, refresh]);

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be inside SiteProvider");
  return ctx;
};
